import moment from 'moment';
import { share, takeWhile, map } from 'rxjs/operators';
import { timer } from 'rxjs';
export default (function (leftDuration) {
  var leftDurationSeconds = leftDuration.asSeconds();
  return timer(0, 1000).pipe(takeWhile(function (val) {
    return val <= leftDurationSeconds;
  }), map(function (i) {
    return moment.duration(leftDurationSeconds - i, 'seconds');
  }), share());
});